var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrend = function SvgTrend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.643 2.842H6.74a3.784 3.784 0 0 0-3.784 3.784v8.902a3.784 3.784 0 0 0 3.784 3.784h8.903a3.784 3.784 0 0 0 3.783-3.784V6.626a3.784 3.784 0 0 0-3.783-3.784Z",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.386 8.37a.668.668 0 0 0-.668-.667H12.2a.668.668 0 1 0 0 1.336h.906l-2.15 2.15-1.274-1.273a.668.668 0 0 0-.945 0l-2.832 2.833a.668.668 0 1 0 .944.944l2.36-2.36 1.274 1.273c.26.26.684.26.944 0l2.623-2.623v.906a.668.668 0 0 0 1.336 0V8.371Z",
    fill: "#1E5DFF"
  })));
};
export default SvgTrend;